var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgBenefitIcon = function SvgBenefitIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#676879",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "m5 8.712 1.225 2.018q.07.122.182.194a.464.464 0 0 0 .48.017.55.55 0 0 0 .192-.182L11 5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#676879",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M1 8a7 7 0 1 0 14 0A7 7 0 0 0 1 8"
  })));
};
export default SvgBenefitIcon;